<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="d-flex flex-column justify-center align-center">
      <v-card style="padding: 5px; width: 90%;">
        <v-row>
          <v-col style="text-align: right;">
            total number of sessions recorded:
          </v-col>
          <v-col>
            {{ statistics.sessionCount }}
          </v-col>
        </v-row>
        <v-row>
          <v-col style="text-align: right;">
            number of currently open sessions:
          </v-col>
          <v-col>
            {{ statistics.openSessionCount }}
          </v-col>
        </v-row>
        <v-row>
          <v-col style="text-align: right;">
            average number of queries per session:
          </v-col>
          <v-col>
            {{ statistics.averageConversationLength.toFixed(3) }}s
          </v-col>
        </v-row>
        <v-row>
          <v-col style="text-align: right;">
            average queue wait time:
          </v-col>
          <v-col>
            {{ statistics.queueAverage ? statistics.queueAverage.toFixed(3) : 0 }}s
          </v-col>
        </v-row>
        <v-row>
          <v-col style="text-align: right;">
            average engine response time:
          </v-col>
          <v-col>
            {{ statistics.inFlightAverage ? statistics.inFlightAverage.toFixed(3) : 0 }}s
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
      statistics: {
        sessionCount: 0,
        openSessionCount: 0,
        averageConversationLength: 0,
        queueAverage: 0,
        inFlightAverage: 0,
      },
      busy: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: 'https://alignergpt.com/statistics',
        headers: {
          Authorization: 'Basic ZXF1aXBtZW50OlcvX3lkIy44dldhbyZQRT0=',
        },
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.statistics = res.data;
          console.log(JSON.stringify(this.statistics, null, 2));
        })
        .catch((err) => {
          this.busy = false;
        });
    },
  },
};
</script>
